import React, { createContext, useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const GlobalStateContext = createContext();

export const GlobalStateProvider = ({ children }) => {
  const { i18n } = useTranslation();

  const storedLanguage = localStorage.getItem("selectedLanguage") || "uz";
  const storedVersion = localStorage.getItem("selectedVersion") || "client";

  const [language, setLanguage] = useState(storedLanguage);
  const [siteVersion, setSiteVersion] = useState(storedVersion);

  useEffect(() => {
    i18n.changeLanguage(storedLanguage);
  }, [i18n]);

  useEffect(() => {
    localStorage.setItem("selectedLanguage", language);
    localStorage.setItem("selectedVersion", siteVersion);

    i18n.changeLanguage(language);
  }, [language, siteVersion, i18n]);

  const value = {
    language,
    setLanguage,
    siteVersion,
    setSiteVersion,
  };

  return (
    <GlobalStateContext.Provider value={value}>
      {children}
    </GlobalStateContext.Provider>
  );
};

export const useGlobalState = () => {
  return useContext(GlobalStateContext);
};
